import { render, staticRenderFns } from "./ListBooking.vue?vue&type=template&id=50ccc6e2&"
import script from "./ListBooking.vue?vue&type=script&lang=js&"
export * from "./ListBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports